<div class="col-md-12">

	<table class="table table-responsive table-hover">
		<tr class="text-color-top2">
			<th colspan="4"><pagination-controls class="itemsPerPage-option-width"
					(pageChange)="pageChanged($event)"></pagination-controls></th>
			<th colspan="2" *ngIf="config.totalItems >= 0" class="divider-vertical-header-full-height td-align-right">
				Total Record: {{config.totalItems}}
			</th>
			<th colspan="2" class="divider-vertical-header-full-height td-align-right">
				<mat-select [(value)]="itemPerPageSelection" class="itemsPerPage-option-width"
					(selectionChange)="changeItemSelectionData(itemPerPageSelection, $event)">
					<mat-option value="1">1</mat-option>
					<mat-option value="5">5</mat-option>
					<mat-option value="10">10</mat-option>
					<mat-option value="25">25</mat-option>
					<mat-option value="50">50</mat-option>
				</mat-select>
				Record Page Size
			</th>
		</tr>
		<tr>
			<th>SN</th>
			<th class="divider-vertical-header-full-height">User Id</th>
			<th class="divider-vertical-header-full-height">Name</th>
			<th class="divider-vertical-header-full-height">Sub Name</th>
			<th class="divider-vertical-header-full-height">Nick Name</th>
			<th class="divider-vertical-header-full-height">Registration No</th>
			<th class="divider-vertical-header-full-height">Status</th>
			<th class="divider-vertical-header-full-height">Edit</th>
			<th class="divider-vertical-header-full-height" *ngIf="this.appData.userId=='Admin'">Video Edit</th>
			<th class="divider-vertical-header-full-height">Delete</th>
		</tr>
		<tr *ngFor="let item of records | paginate: config; let i = index ">
			<td>{{i+1}}</td>
			<td class="divider-vertical-data-full-height">{{item.owner?item.owner.loginUserId:""}}</td>
			<td class="divider-vertical-data-full-height">{{item.name}}</td>
			<td class="divider-vertical-data-full-height">{{item.subName}}</td>
			<td class="divider-vertical-data-full-height">{{item.nickName}}</td>
			<td class="divider-vertical-data-full-height">{{item.registrationNo}}</td>
			<td class="divider-vertical-data-full-height">
				<span *ngIf="this.appData.userId!='Admin'">{{item.status}}</span>
				  <mat-select  *ngIf="this.appData.userId=='Admin'" class="status-option-width"
				   [disabled]="item.owner==null || item.status=='DELETED'" [(value)]="item.status" (selectionChange)="changeStatusConfirmation(i, item, $event)">
				    <mat-option value="ACTIVE">Active</mat-option>
				    <mat-option value="BLOCKED">Blocked</mat-option>
				    <mat-option value="DELETED">Deleted</mat-option>
				    <mat-option value="EXPIRED">Expired</mat-option>
				    <mat-option value="INACTIVE">InActive</mat-option>
				  </mat-select>
			</td>
			<td class="divider-vertical-data-full-height"><a [routerLink]="['/eduSys-update',{'id':item.id}]">
				<button mat-button>
					<mat-icon>edit</mat-icon>
				</button>
				</a>
			</td>
			<td class="divider-vertical-data-full-height" *ngIf="this.appData.userId=='Admin'">
				<a [routerLink]="['/video-config',{'id':item.id}]">
				<button mat-button>
					<mat-icon>edit</mat-icon>
				</button>
				</a>
			</td>
			<td class="divider-vertical-data-full-height">
				<button mat-button (click)="deleteEducationSystem(item.id)" [disabled]="item.owner==null || item.status=='DELETED'">
					<mat-icon>delete_forever</mat-icon>
				</button>
				<!--<a [routerLink]="['/eduSys-delete',item.id]" >
				<button [disabled]="item.owner==null || item.status=='DELETED'">
					<mat-icon>delete_forever</mat-icon>
				</button>
				</a>-->
			</td>
		</tr>
		
	</table>
	
</div>